import { Link } from "react-router-dom";
import checkLogo from "../../assets/images/circle-check.svg";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";

const ChangePWSuccessUI = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="my-4 w-100 d-flex justify-content-center">
        <img src={checkLogo} alt="" width={96} height={96} />
      </div>
      <div className="text-center">
        <h4>{t("auth.changePassword.successTitle")}</h4>
        <p className="text-muted">{t("auth.changePassword.successText")}</p>
      </div>
      <div className="my-4">
        <Link to="/account">
          <Button color="warning" type="submit" block>
            {t("auth.actions.account")}
          </Button>
        </Link>
      </div>
    </>
  );
};

export default ChangePWSuccessUI;
